<template>
    <listings-activation-destroy
        v-slot="{
            sid,
            error,
            is_loading: is_saving,
            destroy
        }"
        :params="{
            listing: listing.uuid
        }"
        @success="_.debounce(() => {
            show_destroy_modal = false

            _.debounce(() => {
                show_destroyed_modal = true
            })()
        })()"
    >
        <div>
            <button
                class="text-center w-full bg-grey-bg text-red rounded-b px-4 py-3 sm:px-6"
                @click.prevent="_.debounce(() => { show_destroy_modal = true })()"
            >
                Deactivate Listing
            </button>

            <error-modal
                v-if="error && $error.is(error, { exclude: [422] })"
                :error="error"
            />

            <modal-red
                v-else-if="show_destroy_modal"
                v-slot="{ close }"
                :is-open="show_destroy_modal"
                @close="_.debounce(() => { show_destroy_modal = false })()"
            >
                <base-form @submit="destroy">
                    <div class="pt-4 pb-3 px-4 sm:p-6">
                        <h6 class="text-center font-semibold text-lg font-normal mb-3">
                            Deactivate Listing
                        </h6>

                        <div class="text-grey-darker">
                            <p class="mb-3">Are you sure you want to deactivate your listing?</p>

                            <p class="mb-3">
                                Once deactivate your listing will be removed from search results, and no longer
                                accept applications.
                            </p>

                            <p class="mb-3">
                                You can reactivate this listing at any time.
                            </p>
                        </div>
                    </div>

                    <footer class="flex flex-col md:flex-row-reverse bg-grey-bg rounded-b py-3 px-6">
                        <base-button
                            :is-loading="is_saving"
                            type="submit"
                            class="btn btn-red w-full md:w-auto"
                        >
                            Deactivate
                        </base-button>

                        <button
                            type="button"
                            class="btn text-center md:mr-3"
                            @click.prevent="close"
                        >
                            Cancel
                        </button>
                    </footer>
                </base-form>
            </modal-red>

            <modal-success
                v-else-if="show_destroyed_modal"
                :is-open="show_destroyed_modal"
                @close="_.debounce(() => { show_destroyed_modal = false })(); $emit('success')"
            >
                <template v-slot:heading>Listing deactivated!</template>

                <p class="mb-3">
                    Your listing has been deactivated, but, please note that you can reactivate it at any time.
                </p>

                <template
                    v-slot:footer="{
                        close
                    }"
                >
                    <div class="flex flex-col md:flex-row-reverse">
                        <button
                            type="button"
                            @click.prevent="close"
                            class="btn btn-green text-center"
                        >
                            OK
                        </button>
                    </div>
                </template>
            </modal-success>
        </div>
    </listings-activation-destroy>
</template>

<script>
    import ListingsActivationDestroy from '../../../../../components/listings-activation-destroy'

    export default {
        components: {
            ListingsActivationDestroy
        },
        props: {
            listing: {
                type: Object,
                required: true
            }
        },
        data () {
            return {
                show_destroy_modal: false,
                show_destroyed_modal: false
            }
        }
    }
</script>
